import * as React from 'react';
import { Formik } from 'formik';
import { Trans, withTranslation } from 'react-i18next';

import { Button } from '../../atoms/button';
import { CheckboxGroup } from '../../atoms/form';
import { CheckboxTitle } from './CheckboxTitle';
import { RequestError } from '../../atoms/error';
import { ThemeConsumer } from '../theme';
import {
  buildEmailNotificationsValues,
  buildPushNotificationsValues,
  buildBadgeNotificationsValues,
  mapperToArray,
  mapperToObject,
  pushNotifications,
  emailNotifications,
  badgeNotifications,
} from '../../utils/notifications';

export class Renderer extends React.Component {
  state = {
    response: null,
  };

  buildInitialValues = () => {
    const { push_notifications_settings, email_notifications_settings, badge_notifications_settings } = this.props;
    const pushNotifications = mapperToArray(push_notifications_settings);
    const emailNotifications = mapperToArray(email_notifications_settings);
    const badgeNotifications = badge_notifications_settings ? mapperToArray(badge_notifications_settings) : undefined;

    return {
      enable_push_notifications: [push_notifications_settings.enable_notifications.value],
      enable_email_notifications: [email_notifications_settings.enable_notifications.value],
      enable_badge_notifications: badge_notifications_settings
        ? [badge_notifications_settings.enable_notifications.value]
        : undefined,
      push_notifications_settings: pushNotifications,
      email_notifications_settings: emailNotifications,
      badge_notifications_settings: badgeNotifications,
    };
  };

  render() {
    return (
      <Formik
        initialValues={this.buildInitialValues()}
        onSubmit={async (values, formik) => {
          formik.setSubmitting(true);
          this.setState({ response: null });

          const push_notifications_settings = {
            enable_notifications: values.enable_push_notifications.includes(true),
            ...mapperToObject(pushNotifications, values.push_notifications_settings),
          };

          const email_notifications_settings = {
            enable_notifications: values.enable_email_notifications.includes(true),
            ...mapperToObject(emailNotifications, values.email_notifications_settings),
          };

          const badge_notifications_settings = values.badge_notifications_settings
            ? {
                enable_notifications: values.enable_badge_notifications.includes(true),
                ...mapperToObject(badgeNotifications, values.badge_notifications_settings),
              }
            : undefined;

          const response = await this.props.onSubmit({
            push_notifications_settings,
            email_notifications_settings,
            badge_notifications_settings,
          });

          this.setState({ response: response });
          formik.setSubmitting(false);

          if (response?.ok) {
            this.props.onSuccess(response);
          }
        }}
      >
        {(formik) => {
          return (
            <ThemeConsumer>
              {(theme) => (
                <React.Fragment>
                  {this.props.badge_notifications_settings ? (
                    <React.Fragment>
                      <CheckboxTitle
                        title={<Trans>Badge Notifications</Trans>}
                        name="enable_badge_notifications"
                        value={{ value: true, label: <Trans /> }}
                        id="badge-notifications"
                      />
                      <CheckboxGroup
                        disabled={!formik.values['enable_badge_notifications'].includes(true)}
                        name="badge_notifications_settings"
                        values={buildBadgeNotificationsValues(
                          this.props.badge_notifications_settings,
                          formik.values.badge_notifications_settings,
                        )}
                      />
                    </React.Fragment>
                  ) : null}
                  <CheckboxTitle
                    title={<Trans>Push Notifications</Trans>}
                    name="enable_push_notifications"
                    value={{ value: true, label: <Trans /> }}
                    id="push-notifications"
                  />
                  <CheckboxGroup
                    disabled={!formik.values['enable_push_notifications'].includes(true)}
                    name="push_notifications_settings"
                    values={buildPushNotificationsValues(
                      this.props.push_notifications_settings,
                      formik.values.push_notifications_settings,
                    )}
                  />
                  <CheckboxTitle
                    title={<Trans>E-mail Notifications</Trans>}
                    name="enable_email_notifications"
                    value={{ value: true, label: <Trans /> }}
                    id="email-notifications"
                  />
                  <CheckboxGroup
                    disabled={!formik.values['enable_email_notifications'].includes(true)}
                    name="email_notifications_settings"
                    values={buildEmailNotificationsValues(
                      this.props.email_notifications_settings,
                      formik.values.email_notifications_settings,
                    )}
                  />
                  <div style={{ margin: '25px 0', width: 150 }}>
                    <Button
                      outline
                      block
                      type="submit"
                      color={theme.color.brand}
                      textColor={theme.color.brand}
                      size="lg"
                      title={formik.isSubmitting ? this.props.t('Updating...') : this.props.t('Update')}
                      disabled={formik.isSubmitting}
                      onClick={formik.submitForm}
                      id="btn-update-notifications"
                    />
                  </div>
                  <RequestError response={this.state.response} />
                </React.Fragment>
              )}
            </ThemeConsumer>
          );
        }}
      </Formik>
    );
  }
}

export const NotificationsForm = withTranslation()(Renderer);
